module.exports = __webpack_public_path__ + "static/media/logo_white.a4993055.svg";